import { ReactNode } from 'react';

import {
  parsePhoneNumber,
  formatPhoneNumber,
  digitsOnly,
  TParsedPhoneNumber,
} from '@@/common/formatters/phone';

type TRenderPropArg = {
  formattedNumber: string;
  parsedNumber: TParsedPhoneNumber | null;
};

export type TPhoneLink = {
  'data-testid'?: string;
  className?: string;
  phoneNumber: string;
  children?: (arg: TRenderPropArg) => ReactNode;
};

export default function PhoneLink({
  'data-testid': dataTestId = 'phone-link',
  children,
  className,
  phoneNumber,
}: TPhoneLink) {
  const parsedNumber = parsePhoneNumber(phoneNumber);
  const formattedNumber = formatPhoneNumber(parsedNumber);

  return formattedNumber ? (
    <a
      className={className}
      data-testid={dataTestId}
      href={`tel:${digitsOnly(phoneNumber)}`}
    >
      {children ? children({ formattedNumber, parsedNumber }) : formattedNumber}
    </a>
  ) : null;
}
